enum EVENT_LISTENER {
  LANGUAGE_CHANGED = "language-changed",
  ACC_ES_ROUTER_GO = "acc-es-router-go",
  ACC_REPORT_CHANGE = "accReportChangeEvent",
  EDLOS_VIEW_DOWNLINE_LOS_FROM_PROFILE = "edlos-view-downline-los-from-profile",
}

export const EVENTS = {
  EVENT_LISTENER,
};
